import {useTranslation} from '@aboutyou/i18n';
import {useTrackFeature} from '@aboutyou/tracking';
import {LoadingButton} from '@aboutyou/ui-components';
import React, {startTransition} from 'react';
import styled from 'styled-components';

interface TrackedGoToCheckoutButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  className?: string;
}

export const GoToCheckoutButton: React.FC<TrackedGoToCheckoutButtonProps> = ({
  onClick,
  className,
  isLoading,
}) => {
  const trackFeature = useTrackFeature();
  const {t} = useTranslation();

  const handleClick = () => {
    startTransition(() => {
      trackFeature({
        eventType: 'click',
        label: 'internal_checkout',
        name: 'proceed_checkout',
      });
      onClick();
    });
  };

  return (
    <FullWidthButton
      disableShadow
      data-testid="proceedToCheckoutButton"
      onClick={handleClick}
      isLoading={isLoading}
      className={className}
    >
      {t('Proceed to checkout')}
    </FullWidthButton>
  );
};

const FullWidthButton = styled(LoadingButton)`
  width: 100%;
  transform-origin: 50% 50%;
  animation: shake-animation 0.3s ease normal;
  animation-delay: 1s;

  @keyframes shake-animation {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(5px);
    }
    50% {
      transform: translateX(-5px);
    }
    75% {
      transform: translateX(5px);
    }
    100% {
      transform: translateX(0);
    }
  }
`;
